export default class AauwModals {

  constructor() {
    // 1000 * 60 * 60 * 24
    this.millisecondsPerDay = 86400000;
    this.hasDisplayedModal = false;
    this.$modals = $('#aauw-modals-wrapper .aauw-modal');

    // Set up an alternate "this" variable for use by listeners below
    const self = this;

    // Set up the event listeners.
    // Since there are a number of acceptable criterion for what constitutes a
    // conversion, gather them in to a single listener for a custom event.
    $(document).on('aauw-modal-conversion', '.aauw-modal', function() {
      self.giveModalRestSetting(this, true);
    });

    // .js-aauw-modal-conversion-element is the class expected to be on any <a>
    // that triggers a conversion.
    $(document).on('click', 'a.js-aauw-modal-conversion-element', function() {
      $(this).trigger('aauw-modal-conversion');
    });

    // If the user mouseups with their auxiliary button on a link, assume they are
    // opening it in a new tab and give conversion credit.
    // Possibly erroneous if the user has mapped that button to something else,
    // or for some reason has moved to hover over the link after mousedown. But
    // we'll lean on the side of false positives instead of false negatives.
    $(document).on('mouseup', 'a.js-aauw-modal-conversion-element', function(event) {
      if (event.button === 1) {
        $(this).trigger('aauw-modal-conversion');
      }
    });

    // There is no JS event for opening a link in a new window via context menu,
    // so unfortunately we can't give any credit for that.

    // For forms, we expect the custom aauw-modal-conversion event to be triggered
    // somewhere inside the modal by the relevant form. (Rather than watch
    // 'submit' we put the burden on the other component so that a form that fails
    // submission on the backend doesn't count for conversion.)

    // Specify method that popup management should call
    this.popupManagementCall = this.checkForModal;
  }

  /**
   * Checks if an AAUW modal should be displayed. Returns true if one is
   * displayed, or false if either one shouldn't be displayed or none is
   * available.
   */
  checkForModal() {
    if (this.hasDisplayedModal) {
      // Max of 1 modal displayed per page load
      return false;
    }

    let shouldShowModal = true;
    const now = Date.now(),
          restAllModalsUntil = localStorage.getItem('aauw-modal-rest-all-until');
    if (restAllModalsUntil && restAllModalsUntil > now) {
      shouldShowModal = false;
    }

    if (shouldShowModal) {
      return this.displayNextModal();
    }

    return false;
  }

  /**
   * Evaluate modals on this page and display the next one that the user is
   * eligible to see, if any.
   */
  displayNextModal() {
    let $modalToDisplay = null;
    this.$modals.each(function() {
      const $this = $(this),
            modalId = $this.data('modal-id');
      if (!modalId) {
        throw 'Could not find the modal ID!';
      }

      const now = Date.now(),
            localStorageId = 'aauw-modal-' + modalId + '-rest-until',
            restExpireTime = localStorage.getItem(localStorageId)
      ;

      if (restExpireTime) {
        // 0 means that the modal should never be shown again
        if (restExpireTime === '0') {
          return true;
        }

        if (now >= restExpireTime) {
          // The rest period for this modal has expired, so we are showing it.
          // Delete the current rest entry.
          localStorage.removeItem(localStorageId);
        } else {
          // The rest period for this modal is ongoing, don't show this modal.
          return true;
        }
      }

      // If we haven't returned yet, this is the modal that's next in line and
      // should be displayed.
      $modalToDisplay = $this;
      // Break the .each() loop
      return false;
    });

    if ($modalToDisplay) {
      const modalToDisplayType = $modalToDisplay.data('post-type').replace(/_/g, '-');
      let mfClasses = `-fade aauw-modal-wrap aauw-modal-wrap-${modalToDisplayType}`;
      if ($modalToDisplay.data('dark-bg')) {
        mfClasses += ' dark-bg';
      }

      // Provide reference back to this object for the close callback
      const self = this;

      $.magnificPopup.open({
        callbacks: {
          close() {
            const $modalItem = this.items[0].src;
            self.giveModalRestSetting($modalItem, false);
            $modalItem.trigger('aauw-popup-closed');
          }
        },
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span class="sr-text">Close Pop-up</span></button>',
        closeOnBgClick: false,
        mainClass: mfClasses,
        items: {
          src: $modalToDisplay,
          type: 'inline'
        },
        removalDelay: 150
      });

      this.hasDisplayedModal = true;

      return true;
    }

    // We didn't display a modal
    return false;
  }

  /**
   * Set a local storage entry to prevent a given modal from being displayed
   * again.
   */
  giveModalRestSetting($modalElement, userConverted) {
    if (!$modalElement) {
      throw 'Not passed a modal element!';
    }

    if (!($modalElement instanceof jQuery)) {
      $modalElement = $($modalElement);
    }

    const modalId = $modalElement.data('modal-id');
    if (!modalId) {
      throw 'Could not find the modal ID!';
    }

    const now = Date.now();

    // Let the user avoid ALL modals for a brief time.
    // Reset the clock for five minutes later: now + (1000 * 60 * 5)
    localStorage.setItem('aauw-modal-rest-all-until', now + 300000);

    const localStorageId = 'aauw-modal-' + modalId + '-rest-until',
          currentRestExpireTime = localStorage.getItem(localStorageId)
    ;
    if (currentRestExpireTime === '0') {
      // 0 means never again. It's already the longest expiration possible, so
      // we don't need to overwrite it.
      return false;
    }

    let restExpireTime = userConverted ? $modalElement.data('converted-rest-period') : $modalElement.data('rest-period');
    if (typeof restExpireTime === 'undefined') {
      throw 'Could not find the modal rest period!';
    }
    if (restExpireTime !== 0) {
      restExpireTime = Date.now() + (restExpireTime * this.millisecondsPerDay);

      if (restExpireTime < currentRestExpireTime) {
        // Don't overwrite a longer existing expiration period, if that case
        // somehow comes up
        return false;
      }
    }

    localStorage.setItem(localStorageId, restExpireTime);
    return true;
  }

}
